import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  onThemeSelectionChange(evt) {
    const theme = evt.currentTarget.value;
    document.documentElement.dataset.theme = theme;
    this.element.closest("form").requestSubmit();
  }
}
